import { render, staticRenderFns } from "./Simulador.vue?vue&type=template&id=7292839b&scoped=true&"
import script from "./Simulador.vue?vue&type=script&lang=js&"
export * from "./Simulador.vue?vue&type=script&lang=js&"
import style0 from "./Simulador.vue?vue&type=style&index=0&id=7292839b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7292839b",
  null
  
)

export default component.exports